import { authenticatedApi } from '../api';

const API_MODERATION_REPORT_CATEGORY_PATH = '/moderation/reportCategory';

export const fetchAllReportCategory = async () => authenticatedApi.get(
	`${API_MODERATION_REPORT_CATEGORY_PATH}`,
);
